import { defineComponent as _defineComponent } from 'vue'
import { computed, ref, watch } from 'vue';
import { NewFormData } from '@/interfaces/components/clients/NewFormData';
import { formatNumberForDisplay, parseValue } from '@/helpers/NumberFormatter';

interface Props {
  modelValue?: NewFormData;
  controlTypes?: any[];
}


export default /*#__PURE__*/_defineComponent({
  __name: 'StatusInformation',
  props: {
    modelValue: null,
    controlTypes: null
  },
  emits: [
  'update:blockedOrders',
  'update:blockedDelivery',
  'update:blockedProduction',
  'update:overpaymentAmount',
  'update:openAmount',
  'update:limitAmount',
  'update:controlType'
],
  setup(__props: any, { emit }) {

const props = __props as {
  modelValue?: NewFormData;
  controlTypes?: any[];
};





const overpaymentInput = ref('');
const openAmountInput = ref('');
const limitAmountInput = ref('');

const overpaymentError = ref(false);
const openAmountError = ref(false);
const limitAmountError = ref(false);

const inputRefs: Record<string, any> = {
  overpaymentAmount: overpaymentInput,
  openAmount: openAmountInput,
  limitAmount: limitAmountInput,
};

const errorRefs: Record<string, any> = {
  overpaymentAmount: overpaymentError,
  openAmount: openAmountError,
  limitAmount: limitAmountError,
};

function formatValue(val: number | string | null | undefined): string {
  return formatNumberForDisplay(val, 0, 20);
}

watch(() => props.modelValue, (val) => {
  if (!val) {
    return;
  }
  overpaymentInput.value = formatValue(val.overpaymentAmount);
  openAmountInput.value = formatValue(val.openAmount);
  limitAmountInput.value = formatValue(val.limitAmount);
}, { immediate: true, deep: true });

function onInput(value: string, field: string): void {
  const { valid } = parseValue(value);
  setError(field, !valid);

  if (inputRefs[field]) {
    inputRefs[field].value = value;
  }
}

function onBlur(field: string): void {
  const rawValue = inputRefs[field]?.value || '';
  const { num } = parseValue(rawValue);
  
  emit(`update:${field}`, num);
  
  const formatted = formatValue(num);
  if (inputRefs[field]) {
    inputRefs[field].value = formatted;
  }
}

function setError(field: string, state: boolean): void {
  if (errorRefs[field]) {
    errorRefs[field].value = state;
  }
}

function getValue(key: keyof NewFormData): string | undefined {
  const val = (props.modelValue as any)?.[key];
  if (val != null) {
    return String(val);
  }
  return undefined;
}

const formattedControlTypes = computed(() => {
  return (props.controlTypes ?? []).map((item: any) => {
    return {
      label: item.code ? `(${item.code}) ${item.description}` : item.description,
      value: String(item.id),
    };
  });
});

return { __sfc: true,props, emit, overpaymentInput, openAmountInput, limitAmountInput, overpaymentError, openAmountError, limitAmountError, inputRefs, errorRefs, formatValue, onInput, onBlur, setError, getValue, formattedControlTypes }
}

})